import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";

export const useDriverStore = defineStore("drivers", () => {
  const drivers = ref([]);
  const isLoading = ref(false);

  // Availability check method
  const checkDriversAvailability = async (params) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.get("/api/drivers/check-availability", {
        params: {
          date: params.date,
          selectedVehicle: params.selectedVehicle,
        },
      });
      return response.data.data;
    } catch (err) {
      throw (
        err.response?.data?.message || "Failed to check drivers availability"
      );
    } finally {
      isLoading.value = false;
    }
  };

  return {
    drivers,
    isLoading,
    checkDriversAvailability,
  };
});
